module.exports = __webpack_public_path__ + "static/img/videoPic1.ebe42602.png";